import React, { Children, Fragment } from 'react';
import Slider from 'react-slick';
import classNames from 'classnames';
import { hoc } from 'src/core/utils';
import { useCarousel, CarouselProps } from './carousel.props';
import styles from './carousel.module.scss';

/**
 * Renders Carousel
 */
const Carousel = hoc(
  useCarousel,
  ({
    children,
    selectedIndex,
    carouselRef,
    setSelectedIndex,
    onPrevClick,
    onNextClick,
    checkIsArrowHidden,
    ...props
  }) => {
    return (
      <div className={classNames(styles.wrapper, styles.carousel_container)}>
        <Slider
          ref={carouselRef}
          className={styles.carousel}
          arrows={false}
          dots={false}
          infinite={true}
          beforeChange={(_, index) => setSelectedIndex(index)}
          {...props}
          slidesToShow={3}
          variableWidth={true}
          centerPadding={'30px'}
          centerMode={true}
        >
          {children}
        </Slider>
      </div>
    );
  }
);

export { Carousel };
